import Vue from 'vue'
import axios from 'axios'
import store from '../store'
const http = axios.create()
http.defaults.timeout = 10000
http.defaults.baseURL = process.env.VUE_APP_BASE_URL

http.interceptors.request.use(function (config) {
  /* const auth = window.localStorage.getItem(process.env.VUE_APP_TOKEN)
  if (auth) {
    config.headers['x-Cf-softcms-token'] = auth
  } */
  config.data.common = {
    uid: store.getters.uid,
    token: store.getters.token,
    app_id: process.env.VUE_APP_PDF_APP_ID
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  const data = response.data || response
  // eslint-disable-next-line camelcase
  const { resp_common } = data
  if (resp_common.ret !== 0) {
    if (resp_common.ret === 4001004) {
      store.commit('logout')
    } else {
      return Promise.reject(new Error(resp_common.msg))
    }
  }
  return Promise.resolve(data)
}, function (error) {
  if (!error.response) {
    // store.commit('logout')
    return Promise.reject(error)
  }
  const response = error.response.data
  return Promise.reject(response)
})

export default http
